import { ScaleControl } from "react-mapbox-gl"
import React, { useMemo } from "react"
import { withStyles } from "@material-ui/core"

const GlobalCss = withStyles({
  "@global": {
    ".scale > div:first-child": {
      boxShadow: "none !important",
    },
  },
})(() => null)

interface MapScaleControlProps {
  darkMode?: boolean
}

export const MapScaleControl = ({ darkMode }: MapScaleControlProps) => {
  const controlStyles = useMemo(() => {
    if (darkMode) {
      return {
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        color: 'white',
        fontSize: '12px',
        borderRadius: '4px',
        padding: '2px 4px',
        marginBottom: '20px'
      }
    } else {
      return {
        color: 'black',
        fontSize: '12px',
        padding: '2px 4px',
        marginBottom: '20px',
        boxShadow: 'none',
        backgroundColor: 'none',
        border: 'none'
      }
    }
  }, [darkMode])
  return <>
    {!darkMode && <GlobalCss />}
    <ScaleControl
      unit="metric"
      className="scale"
      style={controlStyles}
      position="bottom-left"
    />
  </>
}
